define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/core/ExtendedPath",
	"csi/heading/Number",
	"csi/core/Key",
	"csi/reflection"
], function(declare, _, ExtendedPath, NumberRen, Key, reflection) {

	var _quantityKey;

	return declare(NumberRen, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: no need to query by quantity
			return null;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: change context to SalesOrderLineItem
			var lineItem = ctx.getRowNode();
			var urlSize = ctx.getNodeURL();
			ctx.pushParams();
			ctx.keyValue = _.indexOf(lineItem.SalesOrderSizes, urlSize);
			ctx.setNode(lineItem, true);
			ctx.setReadOnly(false);
		},

		releaseContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: pop context
			ctx.pop();
			ctx.keyValue = null;
			this.inherited(arguments);
		},

		headingToHtml: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: render using QuantityPerSize renderer
			_quantityKey = _quantityKey || new Key({
				extendedPath: new ExtendedPath(ctx.getNodeClass()),
				id: "QuantityPerSize"
			});

			var spec = ctx.view.getHeadingSpec(_quantityKey);
			this.inherited(arguments, [ctx, spec.heading, refNode]);
		}
	});
});